function sendGoogleGoal(eventName: string, opts: object = {}) {
  if (process.env.IS_SERVER) {
    return
  }

  if (
    typeof window.gtag === 'function'
    && eventName
    && window.IS_YDOC
  ) {
    window.gtag('event', eventName, opts)
  }
}

export default sendGoogleGoal
